import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dot_element = _resolveComponent("dot-element");
  return _openBlock(), _createElementBlock("div", _mergeProps({
    class: "bar"
  }, _ctx.$attrs), [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.numberOfDotsBefore, dot => {
    return _openBlock(), _createBlock(_component_dot_element, {
      size: 3,
      color: "#D1D1D1"
    });
  }), 256)), $options.position ? (_openBlock(), _createBlock(_component_dot_element, {
    key: 0,
    size: 8,
    color: $props.color
  }, null, 8, ["color"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.numberOfDotsAfter, dot => {
    return _openBlock(), _createBlock(_component_dot_element, {
      size: 3,
      color: "#D1D1D1"
    });
  }), 256))], 16);
}